import _ from 'lodash';
import React from 'react';

import LinkText from 'components/LinkText';
import PaymentStatusTag from 'components/PaymentStatusTag';
import Money from 'components/Money';

import {formatDate} from 'utils/datetime';

import './styles.css';

const LessCashRefunds = ({refunds, openRefundDetailModal}) => {
  if (_.isEmpty(refunds)) {
    return <div />;
  }
  const orderedRefunds = _.orderBy(refunds, 'paymentDate', 'asc');

  return (
    <div className="LessCashRefunds">
      {orderedRefunds.map(refund => {
        return (
          <div className="section" key={refund.id}>
            <div className="header">
              <LinkText onClick={() => openRefundDetailModal(refund.id)}>
                Less Cash Refund →
              </LinkText>
              {refund.voided && (
                <div className="status">
                  <PaymentStatusTag status={PaymentStatusTag.VOIDED} />
                </div>
              )}
              <div className="date">{formatDate(refund.paymentDate)}</div>
            </div>
            <div className="value">
              <Money amount={refund.amountApplied} />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default LessCashRefunds;
